import { ArrowLeft } from 'lucide-react';
import { FacilityLocationForm } from './FacilityLocationForm';
import { useNavigate } from '../../hooks/useNavigate';

interface EditFacilityLocationPageProps {
  facilityId: string;
}

export function EditFacilityLocationPage({ facilityId }: EditFacilityLocationPageProps) {
  const navigate = useNavigate();

  const handleSuccess = () => {
    navigate('facility-locations');
  };

  const handleCancel = () => {
    navigate('facility-locations');
  };

  return (
    <div className="min-h-screen bg-slate-100 p-6">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="mb-6">
          <button
            onClick={handleCancel}
            className="flex items-center gap-2 text-slate-600 hover:text-slate-900 transition-colors mb-4"
          >
            <ArrowLeft className="w-5 h-5" />
            Back to Facility Locations
          </button>
          <h1 className="text-3xl font-bold text-slate-900">Edit Facility Location</h1>
          <p className="text-slate-600 mt-1">Update facility information</p>
        </div>

        {/* Form Card */}
        <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
          <FacilityLocationForm
            facilityId={facilityId}
            onClose={handleCancel}
            onSuccess={handleSuccess}
            isModal={false}
          />
        </div>
      </div>
    </div>
  );
}
